import { Dialog, Transition } from '@headlessui/react'
import { isFunction } from 'lodash'
import { Fragment } from 'react'
import { IC_CHECK_BLACK } from '../../../../../modules/images'
import usePopupStore from '../../../../../store/usePopupStore'

const BottomSheet = (props) => {
  const { id } = props

  const popupClose = usePopupStore((state) => state.close)
  const { data } = usePopupStore((state) => ({
    data: state.data[id],
  }))
  const { bottomSheetList = [], customBody, title, onClose } = data
  const open = !!data

  const closeHandler = () => {
    popupClose({ id })
    if (isFunction(onClose)) {
      onClose()
    }
  }

  return (
    <>
      <Transition appear show={open} as={Fragment}>
        <Dialog as="div" className="relative z-[999]" onClose={closeHandler}>
          {/* BackDrop */}
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="bg-dim fixed inset-0 top-0 left-0 right-0" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full transform overflow-hidden rounded-t-[10px] bg-white align-middle shadow-[0px_-2px_4px_0px_rgba(0,0,0,0.2)] transition-all ">
                  {customBody ? (
                    customBody
                  ) : (
                    <>
                      {title && <div className="text-h2 font-bold mb-[8px] text-left mt-[16px] px-[20px]">{title}</div>}
                      <ul className={styles.container1}>
                        {bottomSheetList?.map((item, idx) => (
                          <li key={idx + 'item'} className={styles.listItem} onClick={() => item.onClick(item.id)}>
                            <span className="flex gap-[18px]">
                              {/* <img src={item.icon} /> */}
                              <span className="text-sBody">{item.label}</span>
                            </span>
                            {item.checked && <img src={IC_CHECK_BLACK} style={{ width: 19 }} alt="Check" />}
                          </li>
                        ))}
                      </ul>
                    </>
                  )}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}

export default BottomSheet

const styles = {
  container1: `z-[999] w-full rounded-t-[10px] border-gray-100 bg-white px-[20px] pb-[34px]`,
  listItem: `flex items-center  justify-between border-b border-gray-100 py-[16px]`,
}
